import { ComponentProps, ReactNode } from 'react';
import { TrashSvg } from 'components/svgs/TrashSvg';
import { useConfirmModal } from 'utils/customHooks/useConfirmModal';
import { useTranslation } from 'react-i18next';
import { RowButton } from './RowButton';

interface DeleteButtonProps extends ComponentProps<typeof RowButton> {
  tooltip?: string;
  testId?: string;
  deleteModalTitle?: string;
  deleteModalContent?: ReactNode;
  deleteModalCancelText?: string;
  deleteModalOkText?: string;
}

export const DeleteButton = ({
  onClick,
  disabled = false,
  tooltip,
  testId = 'delete-button',
  deleteModalTitle,
  deleteModalContent,
  deleteModalCancelText,
  deleteModalOkText,
}: DeleteButtonProps) => {
  const { t } = useTranslation();
  const confirmModal = useConfirmModal();

  const handleDeleteClick = () => {
    confirmModal({
      title: deleteModalTitle || t('Confirm delete'),
      content: deleteModalContent || t('Are you sure you want to delete this?'),
      cancelText: deleteModalCancelText || t('Cancel'),
      okText: deleteModalOkText || t('Yes'),
      onOk: onClick,
    });
  };

  return (
    <RowButton
      onClick={handleDeleteClick}
      icon={<TrashSvg />}
      disabled={disabled}
      tooltip={tooltip}
      testId={testId}
    />
  );
};
